﻿document.addEventListener('DOMContentLoaded', () => {
    const fileInputs = document.querySelectorAll('.file-input');

    if (fileInputs.length) {
        fileInputs.forEach(input => {
            let isMultiple = input.getAttribute('multiple') !== null;
            const fileName = input.parentNode.querySelector('.file-name');
            const fileList = input.parentNode.parentNode.nextElementSibling;
            input.onchange = () => {
                if (input.files.length) {
                    if (isMultiple && typeof fileList !== 'undefined' && fileList !== null) {
                        let li = document.createElement('li');
                        let name = document.createTextNode(input.files[0].name);
                        li.appendChild(name);
                        fileList.append(li);
                    } else {
                        fileName.textContent = input.files[0].name;
                    }
                }
            }
        });
    }
});
